import { SELECTORS } from '$utils/constants';

export const checkValidity = () => {
  const inputElements = Array.from(
    document.querySelectorAll(SELECTORS.inputElements) as NodeListOf<HTMLInputElement>
  );
  for (const input of inputElements) {
    if (input.value === 'default') {
      alert('Please select a value for all fields');
      return false;
    }
  }

  return true;
};

export const checkIfNofiltersAreSelected = () => {
  hideErrorMessage();
  const inputElements = Array.from(
    document.querySelectorAll(SELECTORS.inputElements) as NodeListOf<HTMLInputElement>
  );
  let defaultStateCount = 0;
  for (const input of inputElements) {
    if (input.value === 'default') {
      defaultStateCount += 1;
    }
  }

  console.log('COunt ::', defaultStateCount);

  if (defaultStateCount === 10) {
    showErrorMessage();
    return false;
  }

  return true;
};

const errorText = document.querySelector(SELECTORS.errorLabel) as HTMLDivElement;

const showErrorMessage = () => {
  // errorText.style.visibility = 'visible';
  errorText.style.display = 'block';
};

const hideErrorMessage = () => {
  // errorText.style.visibility = 'hidden';
  errorText.style.display = 'none';
};
